import { render } from "./ClassReport.vue?vue&type=template&id=5f15bae8&ts=true"
import script from "./ClassReport.vue?vue&type=script&lang=ts"
export * from "./ClassReport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__